<template>
	<div>
		<h1 class="title is-3 text-white">
			{{ $t('voting_results') }}
		</h1>
		<h3 class="subtitle is-4 text-white mb-3" v-if="stage_info">
			{{ stage_info.title }}
		</h3>
		<p class="text-white mb-4" style="font-size: 12px; opacity: 0.6;" v-html="$t('data_refreshing_every_20_minutes')"></p>
		<table class="pt-table">
			<tbody>
				<template v-for="movie, index in movies" :key="'movie-'+movie.id">
					<tr v-if="movie.average_vote > 0" class="movie-row">
						<td class="is-text-right">
							{{ index+1 }}.
						</td>
						<td style="width: 90%; padding-right: 10px;">
							<span class="movie_title">
								{{ movie.title }}
							</span>
						</td>
						<td>
							<template v-if="this.stage_info.five_points_system">
								{{ movie.five_points_result }}
							</template>
							<template v-else>
								{{ movie.average_vote }}
							</template>
						</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
import axios from 'axios'

export default{
	props: {
		stage: {
			type: Number,
			required: true
		},
		backdrop: {
			type: String,
			default: 'backdrop'
		}
	},
	data(){
		return {
			movies: [],
			stage_info: null
		}
	},
	mounted(){
		this.getStageResults()

		setInterval(() => {
			this.getStageResults()
		}, 20000)
	},
	methods: {
		async getStageResults(){
			await axios.get(`${process.env.VUE_APP_API_LOCATION}/api/stages/${this.stage}/results`).then(r => {
				this.movies = r.data.movies
				this.stage_info = r.data.stage
			})
		}
	}
}
</script>

<style>
.pt-table{
	color: #fff;
	max-width: 600px;
	margin: 0 auto;
	width: 100%;
	font-size: 15px;
	text-align: left;
}
.pt-table h2.title{
	color: #fff !important;
}

.container h1.text-white,
.container p.text-white,
.text-white{
	color: #fff !important;
}
td.is-text-right{
	text-align: right !important;
	padding-right: 15px;
	opacity: 0.5
}
.movie_title{
	font-weight: 500;
}
.movie-row{
	border-bottom: 1px solid transparent;
}
.movie-row:hover{
	border-bottom: 1px dashed #fff;
}
</style>